import styled from 'styled-components';

export const Title = styled.h2`
  color: var(--color-text-light);
  font-family: var(--font-tertiary);
  font-size: 3.2rem;
  font-weight: normal;
  @media (${({ theme }) => theme.respondTo.desktop}) {
    font-size: 3.8rem;
    margin-left: 4rem;
  }
`;

export const CardsGrid = styled.div`
  color: var(--color-text-light);
  display: grid;
  grid-template-columns: minmax(0, 40rem);
  gap: 3rem;
  justify-content: center;
  margin: 6rem auto 0;
  @media (${({ theme }) => theme.respondTo.tablet}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 4rem;
  }
  @media (${({ theme }) => theme.respondTo.desktop}) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 4rem;
  }
`;
